import { gql } from "@apollo/client";

// Shared by GET_USER_PROFILE (user.ts), the trophySetFeatured mutation
// below, and anywhere else a Trophy gets fetched — one field list to keep in
// sync with the Trophy type.
export const TROPHY_FIELDS = gql`
  fragment TrophyFragment on Trophy {
    key
    tier
    category
    name
    featuredPosition
    value
  }
`;

// Static achievement matrix — fetch once with fetchPolicy: "cache-first" and
// reuse across profile views rather than refetching per visit.
export const GET_TROPHY_DEFINITIONS = gql`
  query GetTrophyDefinitions {
    trophyDefinitions {
      key
      category
      name
      metric
      description
      thresholds
    }
  }
`;

export const TROPHY_SET_FEATURED = gql`
  ${TROPHY_FIELDS}

  mutation TrophySetFeatured($input: TrophySetFeaturedInput!) {
    trophySetFeatured(input: $input) {
      featuredTrophies {
        ...TrophyFragment
      }
      errors {
        code
        field
        message
      }
    }
  }
`;

// Readings for every trophy, earned or not, plus the thresholds to measure them against.
export const GET_TROPHY_PROGRESS = gql`
  query GetTrophyProgress($query: String!) {
    profile(query: $query) {
      trophyProgress {
        key
        tier
        value
      }
    }
    trophyDefinitions {
      key
      name
      description
      thresholds
    }
  }
`;
